// src/pages/OverstockPage.jsx
import React, { useEffect, useState } from "react";
import { Download } from "lucide-react";

export default function OverstockPage() {
  const [blobUrl, setBlobUrl] = useState("");
  const [err, setErr] = useState("");
  const [downloadName, setDownloadName] = useState("nadzasoby.pdf");

  useEffect(() => {
    let url = "";

    (async () => {
      try {
        setErr("");

        const res = await fetch("/api/overstock/generate", {
          method: "POST",
          credentials: "include",
        });

        if (!res.ok) throw new Error("Chyba při generování PDF");

        const blob = await res.blob();
        url = URL.createObjectURL(blob);
        setBlobUrl(url);

        const d = new Date();
        if (!isNaN(d)) {
          const y = d.getFullYear();
          const mm = String(d.getMonth() + 1).padStart(2, "0");
          const dd = String(d.getDate()).padStart(2, "0");
          setDownloadName(`nadzasoby_${y}_${mm}_${dd}.pdf`);
        }
      } catch (e) {
        console.error(e);
        setErr("Nelze načíst PDF přehledu nadzásob.");
      }
    })();

    return () => {
      if (url) URL.revokeObjectURL(url);
    };
  }, []);

  return (
    <div className="bg-white rounded-2xl p-4 shadow-sm border border-blue-100">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-xl font-bold text-blue-900 flex items-center gap-4">
          Přehled nadzásob
        </h2>

        {blobUrl && (
          <a
            href={blobUrl}
            download={downloadName}
            className="flex items-center gap-2 text-sm px-3 py-2 rounded-lg border border-blue-200 hover:bg-blue-50"
          >
            <Download className="w-4 h-4" />
            Stáhnout PDF
          </a>
        )}
      </div>

      {err ? (
        <div className="p-4 text-red-600">{err}</div>
      ) : !blobUrl ? (
        <div className="p-4">Načítání…</div>
      ) : (
        <div className="rounded-lg overflow-hidden border border-blue-100">
          <object
            data={blobUrl}
            type="application/pdf"
            className="w-full"
            style={{ height: "80vh" }}
          >
            <p className="p-4">
              Nelze zobrazit PDF.{" "}
              <a
                href={blobUrl}
                download={downloadName}
                className="text-blue-700 underline"
              >
                Stáhnout PDF
              </a>
            </p>
          </object>
        </div>
      )}
    </div>
  );
}
